export default __webpack_public_path__ + "static/media/0_1.1aec2fbb.png";